	document.addEventListener("DOMContentLoaded", function () {

  // Submenu accordion
  document.querySelectorAll(".submenu-toggle").forEach(toggle => {
    toggle.addEventListener("click", function () {
      const parent = this.closest(".menu-item");
      parent.classList.toggle("open");
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const trigger = document.querySelector(".size-guide-trigger");
  const popup = document.querySelector(".size-guide-popup");
  const closeBtn = document.querySelector(".size-guide-close");
  const overlay = document.querySelector(".size-guide-overlay");

  function openPopup() {
    popup.classList.add("active");
    document.body.style.overflow = "hidden"; // 🔥 STOP background scroll
  }

  function closePopup() {
    popup.classList.remove("active");
    document.body.style.overflow = ""; // 🔥 restore scroll
  }

  trigger?.addEventListener("click", openPopup);
  closeBtn?.addEventListener("click", closePopup);
  overlay?.addEventListener("click", closePopup);
});


document.addEventListener("DOMContentLoaded", function () {

  // =========================
  // SAVE POSITION
  // =========================

  document.addEventListener("click", function (e) {

    const productLink = e.target.closest(".product-grid-item a");

    if (productLink) {

      sessionStorage.setItem(
        "collection_scroll_position",
        window.scrollY
      );

      sessionStorage.setItem(
        "loaded_products_count",
        document.querySelectorAll(".product-grid-item").length
      );

    }

  });

  // =========================
  // AUTO LOAD ALL REQUIRED PRODUCTS
  // =========================

  const targetCount = parseInt(
    sessionStorage.getItem("loaded_products_count")
  ) || 0;

  async function autoLoadProducts() {

    return new Promise((resolve) => {

      function loadNext() {

        const currentCount =
          document.querySelectorAll(".product-grid-item").length;

        console.log(
          "Current Products:",
          currentCount,
          "Target:",
          targetCount
        );

        // enough products loaded
        if (currentCount >= targetCount) {

          resolve();
          return;

        }

        const nextBtn =
          document.querySelector(".js-collection-infinity a");

        // no more pages
        if (!nextBtn) {

          resolve();
          return;

        }

        // click next
        nextBtn.click();

        // wait products append
        setTimeout(loadNext, 2500);

      }

      loadNext();

    });

  }

  // =========================
  // RESTORE SCROLL
  // =========================

  function restoreScroll() {

    const savedScroll =
      sessionStorage.getItem("collection_scroll_position");

    if (!savedScroll) return;

    let attempts = 0;

    const interval = setInterval(() => {

      window.scrollTo({
        top: parseInt(savedScroll),
        behavior: "auto"
      });

      attempts++;

      // stop after stable
      if (attempts > 30) {

        clearInterval(interval);

      }

    }, 300);

  }

  // =========================
  // INIT
  // =========================

  (async function () {

    await autoLoadProducts();

    // wait final render
    setTimeout(() => {

      restoreScroll();

    }, 1000);

  })();

});